import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveVideoConferenceCallLinksRequestFailure({ uuid }) {
      const req = getState().find(({ event }) => event.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isRetrieveVideoConferenceCallLinksRequestPending({ uuid }) {
      const req = getState().find(({ event }) => event.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isRetrieveVideoConferenceCallLinksRequestSuccess({ uuid }) {
      const req = getState().find(({ event }) => event.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
    getVideoConferenceCallLinks({ uuid }) {
      const req = getState().find(({ event }) => event.uuid === uuid);

      return req ? req.links : [];
    },
  };
}

export { createSelector };
